module.exports = __webpack_public_path__ + "static/media/young-bodybuilder.b044ee5a.png";